import clsx from 'clsx';
import React from 'react';

export function Spinner({ className }: { className?: string }): JSX.Element {
  return (
    <div
      className={clsx(
        'animate-spin rounded-full border-b-2 border-primary',
        { 'h-8 w-8': !className },
        className,
      )}
    />
  );
}
